import { render, staticRenderFns } from "./LatestPeriodicalTranslation.vue?vue&type=template&id=14b4ba64&scoped=true"
import script from "./LatestPeriodicalTranslation.vue?vue&type=script&lang=js"
export * from "./LatestPeriodicalTranslation.vue?vue&type=script&lang=js"
import style0 from "./LatestPeriodicalTranslation.vue?vue&type=style&index=0&id=14b4ba64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b4ba64",
  null
  
)

export default component.exports